/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { PRODUCT_TYPE } from 'configs/constants';
import { getSubscriptionDetails } from 'services/api/subscriptionApi';
import { TCard, TSubScriptionState, TSubscriptionType } from 'typings';

export const fetchAllSubscription = createAsyncThunk(
  'spaces/fetchAllSubscription',
  async (payload, thunkAPI) => {
    try {
      const response = await getSubscriptionDetails();
      return response.data;
    } catch {
      return thunkAPI.rejectWithValue('failed');
    }
  }
);

const initialSubscriptionState: TSubScriptionState = {
  subscriptionData: [],
  homeSecuritySubscriptionList: [],
  birdSubscriptionList: [],
  isLoading: false,
  defaultPaymentMethod: null,
  birdDefaultPaymentMethod: null,
  selectedSubscriptionInfo: null
};

export const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState: initialSubscriptionState,
  reducers: {
    clearSubscriptionData: (state) => {
      state.subscriptionData = [];
      state.birdSubscriptionList = [];
      state.homeSecuritySubscriptionList = [];
      state.birdDefaultPaymentMethod = null;
      state.defaultPaymentMethod = null;
      state.selectedSubscriptionInfo = null;
    },
    updateSubscriptionData: (state, action) => {
      state.subscriptionData = action.payload;
    },
    setSelectedSubscriptionInfo: (state, action) => {
      state.selectedSubscriptionInfo = action.payload;
    },
    clearSelectedSubscriptionInfo: (state) => {
      state.selectedSubscriptionInfo = null;
    },
    setDefaultPaymentMethod: (state, action) => {
      state.defaultPaymentMethod = action.payload as TCard;
    },
    setBirdDefaultPaymentMethod: (state, action) => {
      state.birdDefaultPaymentMethod = action.payload as TCard;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllSubscription.fulfilled, (state, action) => {
        state.isLoading = false;
        state.subscriptionData = action.payload as TSubscriptionType[];
        state.homeSecuritySubscriptionList = action.payload.filter(
          (subscription) =>
            subscription.product_id === PRODUCT_TYPE.HOME_SECURITY
        );
        state.defaultPaymentMethod =
          state.homeSecuritySubscriptionList[0]?.card_details;
        state.birdSubscriptionList = action.payload.filter(
          (subscription) => subscription.product_id === PRODUCT_TYPE.BIRD
        );
        state.birdDefaultPaymentMethod =
          state.birdSubscriptionList[0]?.card_details;
      })
      .addCase(fetchAllSubscription.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAllSubscription.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

// Action creators are generated for each case reducer function
export const {
  clearSubscriptionData,
  updateSubscriptionData,
  setSelectedSubscriptionInfo,
  clearSelectedSubscriptionInfo,
  setDefaultPaymentMethod,
  setBirdDefaultPaymentMethod
} = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
